import * as Api from '@ViewModels';
import * as React from 'react';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { DefaultSelectBox, ISelectBoxOption } from '../SelectBox';
import { styleSheet } from './styles';

export function UserFilterSelectBox({
	selectedUser,
	onSelectionChanged,
}: {
	selectedUser?: Api.UserViewModel<Api.IUser>;
	onSelectionChanged: (selection: ISelectBoxOption<Api.ReportUser>) => void;
}) {
	const userSession = useUserSession();
	const filterOptions = React.useMemo(() => {
		const results: ISelectBoxOption<Api.ReportUser>[] = [
			{
				title: userSession.userRole === Api.EUserRole.LimitedUser ? `Sent by Me` : 'All Employees',
				value: Api.ReportUser.All,
			},
		];

		if (userSession.userRole === Api.EUserRole.Admin || userSession.userRole === Api.EUserRole.SuperAdmin) {
			results.push({
				title: 'Sent by Me',
				value: Api.ReportUser.Current,
			});
		}
		results.push({
			title: 'Select an Employee',
			value: Api.ReportUser.User,
		});
		return results;
	}, [userSession.userRole]);
	const onRenderSelectedOptionTitle = (option: ISelectBoxOption<Api.ReportUser>) => {
		let text = '';
		if (option.value === Api.ReportUser.All) {
			text = 'All Employees';
		} else {
			text = selectedUser.id === userSession.user.id ? 'Me' : (selectedUser?.name ?? '...');
		}
		return <span title={text}>{text}</span>;
	};
	return (
		<DefaultSelectBox
			onSelectionChanged={onSelectionChanged}
			onRenderSelectedOptionTitle={onRenderSelectedOptionTitle}
			options={filterOptions}
			menuStyles={[styleSheet.dropdownMenu]}
			selectedOption={filterOptions.find(option => {
				let activeSelection = Api.ReportUser.All;
				if (selectedUser?.id) {
					activeSelection = selectedUser.id === userSession.user.id ? Api.ReportUser.Current : Api.ReportUser.User;
				}
				return activeSelection === option.value;
			})}
			triggerStyles={[styleSheet.dropdownTrigger]}
		/>
	);
}
